module.exports = __webpack_public_path__ + "img/ja.4cbc7c34.webp";